<template>
  <router-view/>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: 'PolicyLayout',
  components: {},
  setup: function () {
    return {}
  },
})
</script>
<style scoped>

</style>
